import { useEffect, useState } from 'react';

export function useIsMobile(px = 768): boolean {
	const [isMobile, setIsMobile] = useState(false);
	// This is a hacky way to determine if the user is on a mobile device
	// It checks if the screen width is less than 768px
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < px);
		};
		handleResize();
		window.addEventListener('resize', handleResize, {
			passive: true,
		});
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return isMobile;
}
